module.exports = __webpack_public_path__ + "img/AR.0cb39220.png";